import Modal from 'react-bootstrap/Modal';
import ConditionedComponent from 'components/ConditionedComponent.js';
import React, { Component } from 'react';
import { Badge} from 'reactstrap';
import { Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import Dropdown from 'react-dropdown'
import ethereum from 'decentralized/ethereum.js';

class DirectMessageModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commentText: '',
        }
    }


    async onMessage() {
        await ethereum.messaging.sendMessage(
            undefined, undefined, undefined, this.state.commentText);

        this.props.hide();
    }

    render() {
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.props.hide}>
              <Modal.Header closeButton>
                <Modal.Title>Message {this.props.userName}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <InputGroup className="tag-sound-input">
                  <Input
                    onChange={(event) => {
                        this.state.commentText = event.target.value;
                        this.setState(this.state);
                    }}
                    type="textarea"
                    value={this.state.commentText}
                    placeholder="Write a note" className="comment-input-box"/>
                  <InputGroupAddon addonType="append">
                    <Button size="sm" onClick={() => this.onMessage()} color="secondary">Send</Button>
                  </InputGroupAddon>
                </InputGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => this.onMessage()}>
                  Done 
                </Button>
                <Button variant="primary" onClick={this.props.hide}>
                  Cancel 
                </Button>
                </Modal.Footer>
                </Modal>
        );
   }
}

export default DirectMessageModal;
